var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"label-select",class:{'bg-pink':_vm.selected},attrs:{"type":"button"}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }